import {hasUserProfilingConsent, hasVendorsConsent} from '../services/privacyService';
import storage from './storage';

type CxenseProperties = {
	id: string
	segments: Array<string>
	marketingSegments: Array<string>
}

export function getCxenseProperties(): CxenseProperties | null {
	if (!hasVendorsConsent([412]) || !hasUserProfilingConsent()) {
		return null;
	}

	return {
		'id': storage.get('_cX_G'),
		'segments': storage.getArray('cxSegments'),
		'marketingSegments': storage.getArray('cxSegments_m')
	};
}
